import { axios } from '../interceptors';
import { LoginResponse } from '../models';
import { UtilService } from './util-service';

class AuthService {
  private static baseUrl = '/auth';

  private static tokenKey = 'rate-swticher-token';

  private static testingDashboardtokenKey = 'testing-dashboard-token';

  public static refreshTokenKey = 'rate-swticher-refresh-token';

  public static async authorize(accountNumber: string, ssn4: string, iaLoginEnabled?: boolean, wiLoginEnabled?: boolean) {
    let headers = UtilService.addFeatureHeader({}, iaLoginEnabled, 'IA_LOGIN');
    headers = UtilService.addFeatureHeader(headers, wiLoginEnabled, 'WI_LOGIN');
    const res = await axios.post<LoginResponse>(
      `${this.baseUrl}/token`,
      { accountNumber, ssn4 },
      { headers },
    );
    return res.data;
  }

  public static async refreshToken(refreshTokenReq: string) {
    const res = await axios.post<LoginResponse>(
      `${this.baseUrl}/token/refresh`,
      { refreshToken: refreshTokenReq },
    );
    return res.data;
  }

  public static getAuthToken(): string | null {
    return sessionStorage.getItem(AuthService.tokenKey);
  }

  public static getTestingDashboardAuthToken(): string | null {
    return sessionStorage.getItem(AuthService.testingDashboardtokenKey);
  }

  public static setAuthToken(token: string) {
    if (!token) {
      sessionStorage.removeItem(AuthService.tokenKey);
      return;
    }
    sessionStorage.setItem(AuthService.tokenKey, token);
  }

  public static setTestingDashboardAuthToken(token: string) {
    if (!token) {
      sessionStorage.removeItem(AuthService.testingDashboardtokenKey);
      return;
    }
    sessionStorage.setItem(AuthService.testingDashboardtokenKey, token);
  }

  public static getRefreshToken(): string | null {
    return sessionStorage.getItem(AuthService.refreshTokenKey);
  }

  public static setRefreshToken(refreshToken: string) {
    if (!refreshToken) {
      sessionStorage.removeItem(AuthService.refreshTokenKey);
      return;
    }
    sessionStorage.setItem(AuthService.refreshTokenKey, refreshToken);
  }
}

export { AuthService };
